import React, { PureComponent, Fragment } from 'react';


class GenericError extends PureComponent {

  componentDidMount(){
    window.scrollTo(0, 0);
  }


  render(){

    const { errorType  } = this.props;

    return (
      <Fragment>

      <div className="genericError">
        <div className="row">
          <div className="column small-12 large-11 large-offset-0-5">
            <div className="row">
              <div className="column small-12" style={{ display: (errorType === '404') ? "block": "none"}}>
                  <h4>404 page is not found</h4>
                  <p>Find an <a href={`${process.env.REACT_APP_WWW_DISCOVERY_URL}${process.env.REACT_APP_DISCOVER_PAGE}`} className="busabout--cta--link orange">Epic Adventure.</a></p>
              </div>
              <div className="column small-12" style={{ display: (errorType === '500') ? "block": "none"}}>
                  <h4>500 Internal server error</h4>
                  <p>Find an <a href={`${process.env.REACT_APP_WWW_DISCOVERY_URL}${process.env.REACT_APP_DISCOVER_PAGE}`} className="busabout--cta--link orange">Epic Adventure.</a></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
    )
  }
}



export default GenericError;



// WEBPACK FOOTER //
// ./src/components/error/genericerror.js